import axios, { AxiosError } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { GET_ZUORA_SIGNATURE_REQUEST, GET_ZUORA_SIGNATURE_SUCCESS, GET_ZUORA_SIGNATURE_FAILURE } from 'constants/zuora';
import { RootState } from '../combineReducers';
import { BillingErrorType, ZuoraIframeSignature } from '../interfaces';
import { Actions as BillingErrorActions, errorCatch } from './billingErrors';

type ZuoraPayload = {
  type: string;
  data: ZuoraIframeSignature;
};

const getZuoraSignatureRequest = () =>
  ({
    type: GET_ZUORA_SIGNATURE_REQUEST
  } as const);

const getZuoraSignatureSuccess = (payload: ZuoraPayload) =>
  ({
    type: GET_ZUORA_SIGNATURE_SUCCESS,
    payload
  } as const);

const getZuoraSignatureFailure = (error: AxiosError) => {
  return {
    type: GET_ZUORA_SIGNATURE_FAILURE,
    error
  } as const;
};

export const getZuoraSignature = (
  type: string
): ThunkAction<void, RootState, null, Actions | BillingErrorActions> => async dispatch => {
  try {
    dispatch(getZuoraSignatureRequest());

    const { data } = await axios.get('/api/v1/billing/PaymentMethod/page', { params: { type } });
    const payload = { type, data };

    dispatch(getZuoraSignatureSuccess(payload));
  } catch (error) {
    dispatch(errorCatch({ place: 'zuoraIframe/getSignature/rejected', data: BillingErrorType.ZuoraIframe }));
    dispatch(getZuoraSignatureFailure(error));
  }
};

export type Actions =
  | ReturnType<typeof getZuoraSignatureRequest>
  | ReturnType<typeof getZuoraSignatureSuccess>
  | ReturnType<typeof getZuoraSignatureFailure>;
